import { LOGIN_RESPONSE_ERROR } from 'common/constants/login';
import { CARD_NAME } from 'common/constants/card';
import { MOBILITY_NAME } from 'common/constants/mobility';
import { NAVIGATION_HISTORY_SEARCH_WIDTH } from 'entities/navigation';
import { E100_PORTAL_SUBSCRIPTION_LINK } from 'features/subscription';

const translates = {
  "yes": "Yes",
  "no": "No",
  "ok": "Ok",
  "apply": "Apply",
  "save": "Save",
  "cancel": "Close",
  "company": "Company",
  "details": "Details",
  "name": "Name",
  "email": "E-mail",
  "phoneNumber": "Phone",
  "volume": "Volume",
  "download": "Download",
  "print": "Print",
  "downloadFile": "Download file",
  "station": "Station",
  "brand": "Brand",
  "gpsLongitude": "Longitude",
  "gpsLatitude": "Latitude",
  "gpsLongitudeAndLatitude": "Latitude, longitude",
  "stationCategory": "Station category",
  "suitableForTrucks": "Available for trucks",
  "address": "Address",
  "route": "Route",
  "prices": "Prices",
  "reset": "Reset",
  "whereFrom": "Starting point",
  "where": "Destination ",
  "noData": "No data",
  "filter": "Filter",
  "legend": "Legend",
  "exit": "Exit",
  "login": "Login",
  "password": "Password",
  "requestAccess": "Request Access",
  "enter": "Login",
  "nip": "Tax id. no. (NIP)",
  "shares": "Special offers",
  "showResult": "Show result",
  "additionalParameters": "Additional parameters",
  "acceptableValuesRange": "Allowed range of values: {range}",
  "cm": "cm.",
  "kg": "kg.",
  "default": "By default",
  "disabled": "Disabled",
  "vehicleParameters": "Vehicle parameters",
  "duty": "Toll fees",
  "timeManagement": "Time management",
  "now": "Now",
  "any": "Any",
  "departure": "Departure",
  "arrival": "Arrival",
  "timeZoneHours": "Time zone hours",
  "timeZoneMinutes": "Time zone minutes",
  "typeOfRoadsideService": "Type of roadside service",
  "offerAgreement": "Contract offer",
  "paymentInvoice": "Invoice",
  "aboutE100Card": "About E100 card",
  "orderCard": "Order a card",
  "stationActive": "Ordinary",
  "stationDiscont": "Discount+",
  "stationPM": "Power MAX",
  "stationEconom": "Economy",
  "store": "Roadside service",
  "stationSale": "Promotional refuel station",
  "cluster": "Several gas stations at",
  "stationInfo": "Service point information",
  "stationAddress": "Station address",
  "stationNotes": "Station notes",
  "priceUpdated": "Price is updated",
  "country": "Country",
  "relevantOn": "Current on",
  "axesNumber": "Number of axles",
  "grossWeight": "Vehicle gross weight",
  "emissionType": "Emission class",
  "carHeight": "Vehicle height",
  "weightPerAxle": "Weight per axle",
  "trafic": "Traffic",
  "additionalServices": "Additional services",
  "additionalServices.subtitle": "Without the use of a fuel card",
  "buildingRoute.buildRoute": "Calculate route",
  "buildingRoute.routeDetails": "Route details",
  "login.toTheE100Website": "Back to site",
  "east.login.toTheE100Website": "Back to site",
  "login.logInToPersonalAccount": "Log in",
  "login.goBackToPersonalAccount": "Client Login",
  "login.orderCard": "Order a card",
  "login.account": "Account",
  "login.unauthorizedUser": "Unauthorized user",
  "print.listOfRouteServicePoints": "List of services on the route",
  "print.listOfRouteServicePointsWithPrices": "List of services on the route with prices",
  "buildingRoute.stationsFoundOnRoute": "Found stations on route",
  "buildingRoute.intermediatePoint": "Intermediate point",
  "buildingRoute.addPoint": "Additional stop",
  "buildingRoute.addPoint.infoMessage": "You can add a maximum of 8 intermediate points",
  "buildingRoute.error.noSuchCityOrCountry": "There is no such city or country",
  "buildingRoute.error.impossibleToBuildRoute": "Impossible to plot a route",
  "buildingRoute.error.noStartAndEndPointsSelected": "It is impossible to plot a route. Start and end points are not selected.",
  "buildingRoute.error.noStartingPointSelected": "It is impossible to plot a route. Start point are not selected.",
  "buildingRoute.error.noEndpointSelected": "It is impossible to plot a route. End point are not selected.",
  "buildingRoute.error.fuelInTankAmountMoreThantanksTotalVolume": "Fuel amount cannot exceed tank capacity",
  "filter.additionalParameters": "Additional options",
  "filter.gasStationBrand": "Gas station brand",
  "filter.findGasStationBrand": "Find gas station brand",
  "filter.findCountry": "Find a country",
  "filter.selectCountry": "Choose a country",
  "filter.findRegion": "Find Region",
  "filter.region": "Region",
  "filter.servicesAtStation": "Station services",
  "filter.serviceFormat": "Service format",
  "filter.stationCategory": "Station category",
  "filter.findTrack": "Find Track",
  "filter.track": "Track",
  "filter.gasStationFilter": "Filter of the stations",
  "filter.listSP": "List of stations",
  "filter.displayListOfSP": "Display stations list",
  "filter.displayListOfSPWithPrices": "Display stations list with prices",
  "filter.listSPWithPrices": "List of stations with prices",
  "filter.stationFilter": "Filter of the stations",
  "filter.filterResetModal.title": "Reset filter",
  "filter.filterResetModal.text": "Are you sure you want to reset the settings?",
  "filter.authorizationLink1": "To view prices, please",
  "filter.authorizationLink2": "log in",
  "stationInfo.priceUpdated": "Price updated",
  "languages.ru": "Русский",
  "languages.lt": "Lietuvių",
  "languages.en": "English",
  "languages.tr": "Türkçe",
  "languages.pl": "Polski",
  "languages.uk": "Український",
  "languages.es": "Español",
  "orderCardsModal.unitMeasureFuelValume": "l./month",
  "orderCardsModal.possibleLending": "Crediting is possible",
  "orderCardsModal.privacyPoliceDescription": "I agree to e-mail contact",
  "orderCardsModal.representativeOfLegalEntity": "I agree to be contacted via phone",
  "orderCardsModal.privacyPoliceModal.title": "Consent to be contacted by Email",
  "orderCardsModal.privacyPoliceModal.text": "I consent to the processing by E100 International Trade Sp. z o.o. my personal data in the form of an e-mail address for the purpose of sending me marketing information regarding products and services offered by E100 International Trade Sp. z o.o. by means of electronic communication, pursuant to the provisions of art. 10 sec. 1 and 2 of the Act on the provision of electronic services. Detailed rules regarding the processing of personal data and marketing consents are set out in the information clause. Before giving marketing consent, please read its content.",
  "orderCardsModal.representativeOfLegalEntityModal.title": "Consent to be contacted by phone",
  "orderCardsModal.representativeOfLegalEntityModal.text": "I consent to the processing of my personal data in the form of the telephone number provided by me by E100 International Trade Sp. z o.o. in order to conduct marketing activities with the use of telecommunications terminal equipment and automatic calling systems within the meaning of the Telecommunications Law. Detailed rules regarding the processing of personal data and marketing consents are set out in the information clause. Before giving marketing consent, please read its content.",
  "orderCardsModal.orderCard": "Order a card",
  "orderCardsModal.sendRequest": "Send a request",
  "orderCardsModal.description": "Would you like to test E100 fuel card for free? Fill out the form and we will contact you to clarify the terms of delivery.",
  "orderCardsModal.title": "Order a card for free",
  "orderCardsModal.cardCount": "Number of cards",
  "orderCardsModal.prePay": "Prepayment amount",
  "orderCardsModal.prePay.recommendedAmount": "The recommended prepayment amount is 1000 rubles.",
  "orderCardsModal.totalAmount": "Total amount",
  "orderCardsModal.finishRegistration": "Finish registration",
  "orderCardsModal.formSentSuccess": "The order has been sent",
  "orderCardsModal.ru.secondStep.title": "Ordering fuel cards and issuing a payment document",
  "orderCardsModal.ru.thirdStep.title1": "Your order has been accepted,",
  "orderCardsModal.ru.thirdStep.title2": "our manager will contact you soon.",
  "orderCardsModal.ru.thirdStep.subtitle": "Thank you for choosing E100!",
  "orderCardsModal.ru.thirdStep.numberOfCards": "Number of E100 cards",
  "orderCardsModal.ru.thirdStep.prePay": "Prepayment amount",
  "orderCardsModal.ru.thirdStep.description1": "Below you can find a commercial proposal,",
  "orderCardsModal.ru.thirdStep.description2": "a contract offer, and an invoice for payment.",
  "orderCardsModal.ru.thirdStep.conditionTitle": "draw your attention to",
  "orderCardsModal.ru.thirdStep.conditionText1": "Payment of the invoice is acceptance of the terms of the contract offer.",
  "orderCardsModal.ru.thirdStep.conditionText2": "In each invoice in the column 'purpose of payment,' it is necessary to indicate the number of your contract offer. Your contract offer number.",
  "stationSearch.title": "Search (gas station code, coordinates, address)",
  "stationInfo.availableAtGasStations": "Available at petrol stations",
  "stationInfo.aboutStation": "About station",
  "stationInfo.refillsByCard": "Refueling by fuel card",
  "stationInfo.serviceDescriptionForSpain": "* The price includes a discount from the Spanish government of 0.20 € (valid until 12/31/2022).",
  "error.fieldCannotBeEmpty": "The field cannot be empty",
  "error.onlyLatinLettersAndNumbers": "Only Latin numbers and letters",
  "error.allowedNumberCharacters": "The allowed number of characters",
  "erorr.emailNotValid": "Е-mail is not valid",
  "error.invalidCharacter": "Invalid character",
  "error.phoneNotValid": "The phone number is not valid",
  "buildingRoute.error.consumptionAwareRouting": "Incorrect data. The remaining fuel in the tank is {liters} liters.",
  [`error.${LOGIN_RESPONSE_ERROR.userOrPasswordInvalid}`]: 'Invalid data',
  [`error.${LOGIN_RESPONSE_ERROR.accessError}`]: 'Please contact your E100 regional manager',
  [`error.${LOGIN_RESPONSE_ERROR.passwordNeedsToBeReplaced}`]: 'Your password must be changed',
  [`error.${LOGIN_RESPONSE_ERROR.loginTemporarilyBlocked}`]: 'The ability to enter was blocked for 15 minutes.',
  [`error.${LOGIN_RESPONSE_ERROR.loginFromWrongTerritory}`]: 'Incorrect login credentials entered. Please call the hotline',
  "error.startAndEndDates": "The end date and time shall be later than the start date and time",
  "error.rangeStartAndEndDates": `Search range cannot exceed ${NAVIGATION_HISTORY_SEARCH_WIDTH} days`,
  "km": "km.",
  "loading": "Loading...",
  "filter.closeWindow.text": "Are you sure you want to close the window (the parameters will be reset)",
  "hours": "h.",
  "min": "min.",
  "24/7": "24 hours a day",
  "withoutTechnicalBreaks": "Without taking into account technical breaks",
  "workingHours": "Working hours",
  "monday": "MO",
  "tuesday": "TU",
  "wednesday": "WE",
  "thursday": "TH",
  "friday": "FR",
  "saturday": "SA",
  "sunday": "SU",
  "weekend": "Closed",
  "noWorkHours": "There are no data on working hours",
  "refuelingMode": "Refueling mode",
  "avoid": "Avoid",
  "highways": "Highways",
  "tolls": "Tolls",
  "roads": "Roads",
  "ferries": "Ferries",
  "netto.serviceDescription": `The Net price on the ${CARD_NAME} invoice may differ depending on the local time of the station, as well as due to rounding, currency conversions, devaluation processes, and the time of arrival at the refuel stations.`,
  "includeNettoPrices": "Include Net price",
  "confirmSubmitFilterFormModal.title": "Attention",
  "confirmSubmitFilterFormModal.text1": "The stations shown may have gas stations that only support refueling through a mobile application.",
  "confirmSubmitFilterFormModal.text2": "Pay attention to the \"Refueling mode\" filter.",
  "confirmSubmitFilterFormModal.link": `Learn more about ${MOBILITY_NAME}`,
  "brutto": "Gross price",
  "netto": "Net price",
  "availableServicesAtStation": "Available services at the station",
  "copy": "Copy",
  "replicate": "Copy",
  "copied": "Copied",
  "authModal.title": "Log in using your E100 Personal Account credentials",
  "authModal.info": "Authorization is required to access all features of LocatorPRO.",
  "map": "Map",
  "satellite": "Satellite",
  'feedbackModal.addReview': 'Leave a review',
  'feedbackModal.attachFile': 'Attach a file',
  'feedbackModal.fileMaxSize': 'Files in the following formats can be attached PNG, JPG, PDF, MOV, MPEG. Total volume of files should not exceed 25 MB.',
  'feedbackModal.review': 'Your review',
  'feedbackModal.fileMaxSizeErr': 'The file was not added. Total size of the files exceeds {size} MB',
  'feedbackModal.contactPhone': 'Contact phone number',
  'feedbackModal.contactEmail': 'Contact email address',
  'feedbackModal.reviewInfoMsg': 'Leave feedback about the Client Portal',
  'feedbackModal.reviewInfoMsg2': 'Write your review about the work of your personal account to improve our service.',
  'feedbackModal.send': 'Send',
  'feedbackModal.cancel': 'Cancel',
  'feedbackModal.name': 'Name',
  'feedbackModal.phoneOrEmail': 'Contact email or phone number',
  "feedbackModal.fieldCannotBeEmpty": "Field can not be empty",
  "feedbackModal.invalidPhoneNumber": "Invalid phone number",
  "feedbackModal.invalidEmail": "Invalid email address",
  "feedbackModal.success": "Thank you. Your review was sent",
  "feedbackModal.error": "Something went wrong. Please try again later.",
  "somethingGoWrong": "Something went wrong",
  "e100OnlineMessage.title": "Only online refuelling is possible",
  "e100OnlineMessage.description": `Only refueling via the ${CARD_NAME} mobile app is available. Plastic fuel cards are not accepted. Learn more about online refueling:`,
  "locatorSettings": "Locator settings",
  "netPriceDisplay": "Display of NET prices",
  "autoScaling": "Autoscaling",
  "servicePointDisplayRadius": "Maximum distance of a fuel station from the planned route",
  "servicePointDisplayRadius.label": "Distance in km",
  "differentPrice.title": 'The sign "~" indicates that the cost may vary depending on the selected product or service.',
  "showCars": "Show vehicles",
  "hideCars": "Hide vehicles",
  "secureEBox": "Secure E-BOX",
  "clientCars.modal.text1": "Do you want to see the location of your vehicles in the E100 locator?",
  "clientCars.modal.text2": "Login and activate the Secure E-BOX service.",
  "clientCars.modal.text3": "Activate the Secure E-BOX service.",
  "clientCars.modal.text4": "Do you want to check your vehicles' travel thistory using the E100 locator?",
  "auto": "Vehicle",
  "card": "Card",
  "OBU": "OBU",
  "coordinates": "Coordinates",
  "updateTime": "Update time",
  "moreDetailed": "More details",
  "reports": "Reports",
  "preparationForExport": "Export preparation",
  "readyToDownload": "Ready to download",
  "hasStationLimitBeenExceeded": "The number of stations should not exceed 1000",
  "reportErrorTooltip": "An error occurred, please try again",
  "hideStations": "Hide Stations",
  "showStations": "Show Stations",
  "comment": "Comment",
  "share": "Share",
  "sharedStationLinkModal.text1": "Write a comment for the driver (optional).",
  "sharedStationLinkModal.text2": "Send the copied text to the driver in any convenient way (for example, through messaging apps).",
  "shareStationLinkMessage.text1": "Share information about the gas station",
  "shareStationLinkMessage.text2": "is here",
  "shareStationLinkMessage.text3": "If you don't have the app installed, be sure to download",
  "shareStationLinkMessage.text4": "Continue after installation",
  "messageCopied": "Text copied",
  "copyMessage": "Copy text",
  "cardsLinkedToOBU": "Cards linked to OBU",
  "showLinkedCards": "Show added cards",
  "routesHistory": "Route history",
  "autoNumber": "Vehicle registration plate",
  "showHistory": "Show history",
  "start": "Start",
  "end": "End",
  "communicationLackWithOBU": "No communication with OBU",
  "trafficStop": "Travel stop",
  "copyСoordinates": "Copy coordinates",
  "navigationHistoryStartLocationWarningMessage": "A discrepancy has been detected between the specified start date and the actual date when the first coordinate was received. <br /><br /> Perhaps, the OBU was switched off at the start time you've specified",
  "navigationHistoryEndLocationWarningMessage": "A discrepancy has been detected between the specified end date and the actual date when the last coordinate was received. <br /><br /> Perhaps, the OBU was switched off before the expiration of time you've specified",
  "consumptionAwareRouting": "Routing with consumption consideration",
  "fuelConsumptionTable": "Fuel consumption table",
  "km/h": "km/h",
  "l.": "L",
  "vehicleSpeed": "Vehicle speed",
  "сonsumption": "Consumption",
  "averageFuelConsumption": "Average fuel consumption",
  "fuelInTankAmount": "Fuel amount in tank",
  "tanksTotalVolume": "Total tank capacity",
  "fuelRemainingPercentageInTank": "Remaining fuel percentage",
  "fuelBestPrice": "Best price fuel type",
  "showTollRoadCosts": "Show toll road costs",
  "avoidTolls": "Avoid tolls",
  "additionalSettings": "Additional settings",
  "avoidSelectedCountries": "Avoid selected countries",
  "additionalPointsOnRoute": "Additional services",
  "additionalPointsOnRouteSettings": "Other services",
  "tollsParameters": "Toll parameters",
  "fuelPrice": "Fuel & additional fees",
  "priceType": "Price type",
  "choseFuel": "Choose fuel type",
  "otherTypeOFFuel": "Other type of fuel",
  "countryCurrency": "Price in local currency",
  "priceInEUR": "Price in €",
  "netPrice": "Netto",
  "grossPrice": "Gross",
  "netExcise": "Net excise",
  "heavyTruck": "Heavy truck",
  "lightTruck": "Light truck",
  "car": "Car",
  "myFleet": "My fleet",
  "vehicleCost": "Fuel cost",
  "averageConsumption": "Average consumption",
  "customVehicle": "Custom vehicle",
  "lengthRoad": "Length",
  "toll": "Toll",
  "tollsOnRoute": "Tolls on route",
  "distance": "Distance",
  "totalDriveTime": "Total drive time",
  "fast": "Fast",
  "servicesOnRoute": "Services on route",
  "stationsOnRoute": "Stations on route",
  "all": "All",
  "top5ByCountry": "Top 5 by country",
  "topPriceEvery100km": "Top price every 100 km",
  "priceInCountryCurrency": "Price in country currency",
  "byDefault": "By default",
  "priceLowHight": "Price low - high",
  "priceHightLow": "Price high - low",
  "totalEstCost": "Total est. cost",
  "bestPrice": "Best price",
  "bestPriceIn": "Best price in",
  "bestPriceInRoute": "Best price in {countryCode}<br />on the route",
  "van": "Van",
  "co2EmissionClass": "CO2 emission class",
  "currentWeight": "Current weight",
  "vehicleLength": "Vehicle length",
  "vehicleWidth": "Vehicle width",
  "tiresCount": "Tires count",
  "trailerAxleCount": "Trailer axle count",
  "gettingAvailableRoutes": "Getting Available routes",
  "gettingE100StationsOnRoutes": "Getting E100 stations on routes",
  "gettingBestPricesE100Stations": "Getting best prices E100 stations",
  "displayStationsOnTheRoute": "Display stations on the route",
  "done": "Done",
  "gettingDataFromE100MobileApps": "Getting data from E100 Mobile Apps",
  "gettingDataFromOBU": "Getting data from OBUs",
  "notExistExcisePrice": "Netto (no info about excise)",
  "costDetails": "Cost details",
  "fuelCost": "Fuel cost",
  "otherCosts": "Other cost",
  "priceIsNotAvailable": "Price is not available",
  "paidSectionStart": 'Paid section start',
  "paidSectionEnd": "Paid section end",
  "cost": "Cost",
  "noDataForTheSelectedPeriod": "No data for the selected period",
  "tryChangingThePeriod": "Try changing the period",
  "deviceType": "Device type",
  "locationStatus": "Location status",
  "locationStatusIsGotLess": "Location status is got less {hours}h",
  "locationStatusFromTo": "Strop from {from}h to {to}h",
  "locationStatusIsGotMore": "Location status is got more {hours}h",
  "hoursAgo": "hours ago",
  "searchVehicle": "Search vehicles",
  "activatedServices": "Active services",
  "back": "Back",
  "statistic": "Statistics",
  "averageSpeed": "Average speed",
  "travelTime": "Travel time",
  "truckStop": "Truck stops",
  "driverRest": 'Driver\'s rest',
  "refueling": "Refueling",
  "vehicleType": "Vehicle type",
  "sourceInfo": "Source info",
  "routeCannotBeBuild": "The route cannot be build",
  "linkHasBeenCopied": "The link to the route has been copied",
  "routeBuildingPreferences": "Route preferences",
  "selectAdrClass": "Choose ADR class",
  "explosive": "Explosives",
  "gas": "Gases",
  "flammable": "Flammable liquids",
  "combustible": "Oxidizing substances",
  "organic": "Organic peroxides",
  "poison": "Toxic substances",
  "corrosive": "Infectious substances",
  "radioactive": "Radioactive material",
  "poisonousInhalation": "Corrosive substances",
  "harmfulToWater": "Miscellaneous dangerous substances and articles",
  "other": "Other",
  "trafficAndIncidents": "Traffic and incidents",
  "routeVariants": "Route variants",
  "tollsCost": "Tolls cost",
  "totalCost": "Total cost",
  "selected": "Selected",
  "routeCostDetails": "Route cost details",
  "costsDisplayedInNettoPrice": "Costs displayed in",
  "avgRouteCost": "Avg. cost on the route",
  "allStations": "All stations",
  "itEmptyForNow": "It's empty here for now",
  "AllSelectedStationOnRouteWillBeHere": "All the selected stations on the route will be here",
  "selectedStationOnRoute": "Selected stations on the route",
  "updateRoute": "Update route",
  "addStationOnRoute": "Add station on route",
  "removeStationOnRoute": "Remove station from route",
  "maxStationsOnRoute": "Maximum number of stations on the route",
  "addToRoute": "Add to route",
  "onTheRoute": "On the route",
  "export": "Export",
  "copyLink": "Copy route",
  "avoidFerries": "Avoid ferries",
  "onRightSideOnly": "Avoid stations on opposite side of the road",
  "stationsDisplay": "Displaying service points",
  "tollsPayment": "Tolls payment",
  "costsDisplayedOnMap": "Costs displayed on map",
  "month": "month",
  "start14DaysFreeTrial": "Start 14 Days Free Trial",

  "fleetVisibilityAndGPS": "Fleet Visibility & GPS",
  "fleetVisibilityAndGPS.description1": "Live vehicle tracking",
  "fleetVisibilityAndGPS.description2": "Movement history & analytics",
  "fleetVisibilityAndGPS.description3": "Routes from current vehicle location",
  "fleetVisibilityAndGPS.description4": "Guest tracking access",

  "secureEBoxEcosystem": "Secure E-BOX Ecosystem",
  "secureEBoxEcosystem.description1": "Secure E-BOX included",
  "secureEBoxEcosystem.description2": "E100 Mobile App (free during trial)",
  "secureEBoxEcosystem.description3": "Device configuration anytime in settings",

  "free": "Free",
  "freeTillEnd2025": "Free till the end of 2025",
  "vehicle": "vehicle",

  "locatorProPlannerRoutePlaning": "Smart Route Planning",
  "locatorProPlannerRoutePlaning.description1": "Toll & fuel cost calculation",
  "locatorProPlannerRoutePlaning.description2": "Restrictions & truck parameters",
  "locatorProPlannerRoutePlaning.description3": "Real-time traffic optimisation",
  "locatorProPlannerRoutePlaning.description4": "Alternative route scenarios",

  "allFeaturesAreUnlocked": "All features are unlocked during the trial.",
  "youCanAdjustDevicesAnytimeLaterInSettings": "You can adjust devices anytime later in Settings.",

  "watchTheVideoPresentationOfTheFunctionality": "Watch the video presentation of the functionality",

  "selectVehicleForProPlanActivation": "Select vehicles for PRO plan activation",
  "activation.table.deviceType": "Device type",
  "activation.table.truckNumber": "Truck number",
  "activation.table.card": "Card",
  "activation.table.deviceSerialNumber": "Device s/n",
  "activation.table.status": "Status",
  "activateTheSecureEBOXServiceForTransactionProtectionForFree": "Activate the Secure E-BOX service for transaction protection for free",
  "activate": "Activate",
  "activateAllDevices": "Activate all devices",

  "confirmActivation": "Confirm activation",
  "subscriptionSummary": "Subscription summary",
  "checkSubscriptionDetailsAndConfirmActivationPlanForSelectedVehicles": "Check subscription details and confirm activation plan for selected vehicles",
  "startAfter14DaysTrial": "Start after 14 days trial",
  "currentlyFree": "Currently free",
  "pleaseProvideEmailForActivationConfirmationAndFeedback": "Please provide an email for activation confirmation and feedback",
  "consentToMarketingCommunications": "Consent to marketing communications",
  "consentToLegalMatters": "Consent to legal matters",
  "confirm": "Confirm",
  "total": "Total",

  "updateToProPlan": "Update on PRO",

  "activationRequestHasBeenSent": "The activation request has been sent!",
  "activationWillTakeUp24hours": "Activation will take up to 24 hours",
  "thisIsNecessaryProcessTOSynchronizeData": "This is a necessary process to synchronize your data",

  "managePlan": "Manage subscription",
  "manageProPlan": "Manage PRO plan",
  "deactivateProPlan": "Deactivate PRO plan",
  "confirmChanges": "Confirm changes",
  "nextRenewal": "Next renewal",
  "deactivate": "Deactivate",
  "afterDeactivationAllProFeatureWillBeDisabledAndUnavailable": "After deactivation, all PRO features will be disabled and unavailable",
  "deactivationWillTakeUp24hours": "Deactivation will take up to 24 hours",
  "deactivationRequestHasBeenSent": "Deactivation request has been sent",
  "settings": "Settings",
  'chooseVehicles': 'Choose vehicle',
  'selectVehicleFormYourFleetCreateRouteBasedOnTheParameters': 'Select a vehicle from your fleet to create a route based on the parameters of that vehicle',
  'showStationFilter': "Displaying stations",
  'eBoxDevice': 'E-BOX (on-board device)',
  'e100MobileAppDevice': 'E100 Mobile (mobile application)',
  'sortByDefault': 'By default',
  'sortVehicleNumberAZ': 'Vehicle number A-Z',
  'sortVehicleNumberZA': 'Vehicle number Z-A',
  'sortObuStatusOrder': 'OBU status order',
  'filterRouteHistory.all': 'All',
  'filterRouteHistory.moving': 'Moving',
  'filterRouteHistory.stops': 'Stops',
  'filterRouteHistory.disconnect': 'Disconnect',
  'filterRouteHistory.refueling': 'Refueling',
  'filterRouteHistory.truckStop': 'Truck Stop',
  'filterRouteHistory.parking': 'Parking',
  'historyEvent.fuel': 'Refueling',
  'historyEvent.Parking': 'Truck stop',
  'historyEvent.Service': 'Parking',
  'historyEvent.Untracked': 'Disconnection',
  'navigation.help': 'Help',
  "proPlanTitle": "Locator PRO — your intelligent fleet optimization platform",
  "proPlanSubtitle": "Plan smarter routes, control fleet costs, and track vehicles in real time.",
  "proPlanAfterTrial": "After trial: from 19,99 €/month + devices if selected later",
  "subscribe.gpsObu": "GPS from E-BOX devices",
  "subscribe.obuPrice": "from {price} EUR / vehicle",
  "consentMarketingCommunication": "I consent to the processing by E100 International Trade Sp. z o. o. based in Warsaw, my personal data for the purposes of sending commercial information electronically regarding products and services offered by E100 International Trade Sp. z o. o. , in particular via e-mail address. Consent may be withdrawn at any time.",
  "almostReadyToStartYourFreeTrial": "Almost ready to start your free trial",
  "noChargesDuring14DayTrial": "No charges during the 14-day trial.",
  "afterTrialSubscription": "After trial: subscription from 19,99 €/month.",
  "freeTrialActivationMayTake24Hours": "Free trial activation may take up to 24 hours.",
  "processRequiredSynchronizeYourData": "This process is required to synchronize your data.",
  "youReceiveConfirmationEmailAddressProvidedPreviousStep": "You will receive a confirmation email at the address provided in the previous step.",

  "deactivationReasons.title": "Specify the reason for deactivation:",
  "deactivationReasons.notEnoughFeatures": "Not enough features",
  "deactivationReasons.notUsingService": "Not using the service",
  "deactivationReasons.anotherSolution": "Another solution",
  "deactivationReasons.tooExpensive": "Too expensive",
  "deactivationReasons.other": "Other (specify)",

  "favouriteStations": "Favorite service points",
  "addToFavourite": "Add to Favorites",
  "deleteServicePointFromFavourites": "Remove the Service Point from Favorites",
  "addOnlyThisServicePoint": "Add Service Point to Favorites",
  "favouriteStations.added.message": 'The Service Point has been added to “Favorites”',
  "deleteFromFavorites": "Remove from favorites",
  "delete": "Delete",
  "favouriteStations.deleteModal.message": "Are you sure you want to remove this Service Point from the Favorites list?",
  "error.title": "An error occurred",
  "error.message": "Try opening favorites in a couple of minutes, or reload the tab.",
  "favouriteBrands": "Favorite brands",
  "findBrand": "Find the brand",
  "nothingWasFound": "Nothing found",
  "favouriteStations.emptyItems.warningTitle": "It's empty here for now",
  "favouriteStations.emptyItems.warningMessage": 'To add to the list, click "+" or use the add option in the service point card',
  "findStation": "Find the service point",
  "searchByLists": "Search by brand or SP code",
  "abilityToBeSelectedForYourManager": "The ability to manage favorites for your manager",
  "addEntireBrand": "Add Brand to Favorites",
  "deleteBrandFromFavorites": "Remove the Brand from Favorites",
  "favouriteBrands.deleteModal.message": "Are you sure you want to remove the brand from the Favorites list?",
  "favouriteBrands.added.message": 'The brand has been added to “Favorites”',
  "favourites": "Favorites",
  "favouriteStation": "Favorite service point",
  "countries.AL": "Albania",
  "countries.AD": "Andorra",
  "countries.AM": "Armenia",
  "countries.AT": "Austria",
  "countries.AZ": "Azerbaijan",
  "countries.BY": "Belarus",
  "countries.BE": "Belgium",
  "countries.BA": "Bosnia and Herzegovina",
  "countries.BG": "Bulgaria",
  "countries.HR": "Croatia",
  "countries.CY": "Cyprus",
  "countries.CZ": "Czech Republic",
  "countries.DK": "Denmark",
  "countries.EE": "Estonia",
  "countries.FI": "Finland",
  "countries.FR": "France",
  "countries.GE": "Georgia",
  "countries.DE": "Germany",
  "countries.GR": "Greece",
  "countries.HU": "Hungary",
  "countries.IS": "Iceland",
  "countries.IE": "Ireland",
  "countries.IT": "Italy",
  "countries.KZ": "Kazakhstan",
  "countries.XK": "Kosovo",
  "countries.LV": "Latvia",
  "countries.LI": "Liechtenstein",
  "countries.LT": "Lithuania",
  "countries.LU": "Luxembourg",
  "countries.MT": "Malta",
  "countries.MD": "Moldova",
  "countries.MC": "Monaco",
  "countries.ME": "Montenegro",
  "countries.NL": "Netherlands",
  "countries.MK": "North Macedonia",
  "countries.NO": "Norway",
  "countries.PL": "Poland",
  "countries.PT": "Portugal",
  "countries.RO": "Romania",
  "countries.SM": "San Marino",
  "countries.RS": "Serbia",
  "countries.SK": "Slovakia",
  "countries.SI": "Slovenia",
  "countries.ES": "Spain",
  "countries.SE": "Sweden",
  "countries.CH": "Switzerland",
  "countries.TJ": "Tajikistan",
  "countries.TR": "Turkey",
  "countries.UA": "Ukraine",
  "countries.GB": "United Kingdom",
  "countries.VA": "Vatican City",
  "countries.RU": "Russia",
  "userGeolocation.permissionDenied": "User denied permission to access their geolocation",
  "userGeolocation.timeout": "Geolocation request timed out",
  "userGeolocation.positionUnavailable": "Unable to retrieve position",
  "bus": "Bus",
  "consentData.tooltip.text.pro.planer": `I consent to the disclosure or transfer, for the purposes of providing the LocatorPRO Planner service, of geolocation data concerning the user of the service, including data on journeys planned using the service relating to the device or vehicle of the service user, having been informed that the activation and operation of the service involves the processing of personal data within the meaning of Regulation (EU) 2016/679 (GDPR) by the personal data Controller, E100 International Trade sp. z o.o., with its registered office in Warsaw. Full information on the processing of personal data by the Controller is available on the E100 portal at <a class="link" href="${E100_PORTAL_SUBSCRIPTION_LINK}" target="_blank" rel="noreferrer">E100 portal link</a>. If the client discloses or transfers data processed through LocatorPRO to third parties, the client bears sole responsibility for such data as its controller.`,
  "consentData.tooltip.text.gps": `I consent to the disclosure or transfer, for the purposes of the LocatorPRO GPS service, of geolocation data concerning the user of the service, including data (including historical data) on the position of the vehicle or device of the service user in connection with journeys made by the service user using the service, having been informed that the activation and operation of the service involves the processing of personal data within the meaning of Regulation (EU) 2016/679 (GDPR) by the personal data Controller, E100 International Trade sp. z o.o., with its registered office in Warsaw. Full information on the processing of personal data by the Controller is available on the E100 portal at <a class="link" href="${E100_PORTAL_SUBSCRIPTION_LINK}" target="_blank" rel="noreferrer">E100 portal link</a>. If the client discloses or transfers data processed through LocatorPRO to third parties, the client bears sole responsibility for such data as its controller.`
};

export default translates;
